module.exports = __webpack_public_path__ + "static/018-289e5a8d9637207125d57c7fb241c86a.jpg";